import React from 'react'
import './ComingSoon.css';

const ComingSoon = (props) => {

  return(
    <div className="notifyBox">

  <h2>{props.text}</h2>

    </div>
  )
}

export default ComingSoon;